module.exports = __webpack_public_path__ + "img/brgr-logo-black.ef83ef10.svg";